import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/beautyful-traffic-seoul-night-cityscape-south-korea-with-motion-blur.jpg';

function TrafficRoadSafety() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Traffic and Road Safety Enforcement" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Traffic and Road Safety Enforcement</h4>
              <p>
                This sub-department is dedicated to ensuring public safety on roadways through effective traffic law enforcement and educational initiatives.<br />
                Programs include driver safety workshops, pedestrian awareness campaigns, and road infrastructure assessments to prevent accidents and improve traffic flow.<br /><br />
                By prioritizing safety and compliance, we aim to reduce traffic-related incidents and foster a culture of responsible road use.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Traffic Law Enforcement</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Driver Safety Workshops</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Road Safety Awareness Campaigns</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to creating safer roads for everyone by enforcing traffic laws, educating the public, and improving road conditions.
              </p>
            </div>
            <div>
              <Link to="/department/public-safety">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficRoadSafety;
